import { type AgentDatasetSelector } from './agents-api'

export const agentKeys = {
  root: ['agents'] as const,
  list: (entityId: string) => ['agents', 'list', entityId] as const,
  health: (entityId: string) => ['agents', 'health', entityId] as const,
  detail: (entityId: string, agentId: string) =>
    ['agents', 'detail', entityId, agentId] as const,
  connectionHistory: (entityId: string, agentId: string) =>
    ['agents', 'connection-history', entityId, agentId] as const,
  operation: (entityId: string, agentId: string, operationId: string) =>
    ['agents', 'operation', entityId, agentId, operationId] as const,
  operationLog: (
    entityId: string,
    agentId: string,
    operationId: string,
    taskId: string,
  ) => ['agents', 'operation-log', entityId, agentId, operationId, taskId] as const,
  diagnosticBundles: (entityId: string, agentId: string) =>
    ['agents', 'diagnostic-bundles', entityId, agentId] as const,
  upgradeTargets: (entityId: string, agentId: string) =>
    ['agents', 'upgrade-targets', entityId, agentId] as const,
  configuration: (entityId: string) =>
    ['agents', 'configuration', entityId] as const,
  datasets: (entityId: string, agentId: string) =>
    ['agents', 'datasets', entityId, agentId] as const,
  datasetViews: (entityId: string, agentId: string) =>
    ['agents', 'dataset', entityId, agentId] as const,
  collectionVisibility: (entityId: string, agentId: string, operationId: string) =>
    ['agents', 'collection-visibility', entityId, agentId, operationId] as const,
  datasetCollectionOptions: (entityId: string, agentId: string) =>
    ['agents', 'dataset-collection-options', entityId, agentId] as const,
  datasetRevision: (
    entityId: string,
    agentId: string,
    selector: AgentDatasetSelector,
    epochId: string,
    revision: string,
  ) => ['agents', 'dataset', entityId, agentId, 'revision', selector, epochId, revision] as const,
  datasetView: (
    entityId: string,
    agentId: string,
    view: 'snapshot' | 'revisions' | 'reconciliation',
    selector: AgentDatasetSelector,
  ) => ['agents', 'dataset', entityId, agentId, view, selector] as const,
  canonicalAssetDatasets: (entityId: string, assetId: string) =>
    ['agents', 'canonical-asset-datasets', entityId, assetId] as const,
  canonicalAssetDatasetSnapshot: (
    entityId: string,
    assetId: string,
    selector: AgentDatasetSelector & { agentId: string },
  ) => ['agents', 'canonical-asset-dataset', entityId, assetId, selector] as const,
}

export const pskKeys = {
  root: ['agent-psks'] as const,
  list: (entityId: string) => ['agent-psks', 'list', entityId] as const,
}

export const snmpKey = (entityId: string) => ['agents', 'snmp-configuration', entityId] as const
